import { render, staticRenderFns } from "./UpdatePopularItemDialog.vue?vue&type=template&id=61c815d3&scoped=true&"
import script from "./UpdatePopularItemDialog.vue?vue&type=script&lang=js&"
export * from "./UpdatePopularItemDialog.vue?vue&type=script&lang=js&"
import style0 from "./UpdatePopularItemDialog.vue?vue&type=style&index=0&id=61c815d3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c815d3",
  null
  
)

export default component.exports